import { useInRouterContext, useLocation } from 'react-router-dom';
import { useOptionalChatSheet } from '../state/chat-sheet';
import { useActiveProfFigure } from '../state/active-prof-figure';
import { scopedTopicKeyFor } from '../state/scoped-chat';
import { useScreenFlow } from '../state/screen-flow';
import { useTokens } from '../state/theme';
import { profFigureAssetRef, type ProfFigureSelection } from '../types/prof-figure';

export function SelectProfFigureButton({ selection }: { selection: ProfFigureSelection }) {
  const inRouter = useInRouterContext();
  const sheet = useOptionalChatSheet();
  if (!inRouter || !sheet || !profFigureAssetRef(selection.imageRef)) return null;
  return <ConnectedSelection selection={selection} open={sheet.open} />;
}

function ConnectedSelection({ selection, open }: { selection: ProfFigureSelection; open: () => void }) {
  const { pathname } = useLocation();
  const { key } = useScreenFlow();
  const tokens = useTokens();
  const topicKey = scopedTopicKeyFor(key, pathname);
  if (!topicKey) return null;
  return <button type="button"
    aria-label={`Usa questa figura: ${selection.label}`}
    onClick={(event) => {
      event.stopPropagation();
      useActiveProfFigure.getState().setSelection({ ...selection, topicKey, pathname, selectionId: crypto.randomUUID() });
      open();
    }}
    style={{ display: 'block', flexShrink: 0, minHeight: 44, padding: '6px 10px', marginTop: 6,
      border: `1px solid ${tokens.line}`, borderRadius: tokens.radius.sm,
      color: tokens.accentInk, background: tokens.surface, fontFamily: tokens.fonts.body,
      fontSize: 12, cursor: 'pointer' }}>
    Usa questa figura
  </button>;
}
